module.exports = __webpack_public_path__ + "img/funnel-oldmutual.560ecd30.png";